import { render } from "./SelectCountry.vue?vue&type=template&id=05989194"
import script from "./SelectCountry.vue?vue&type=script&lang=js"
export * from "./SelectCountry.vue?vue&type=script&lang=js"
script.render = render

export default script